import request from 'superagent';

import * as types from 'constants/ActionTypes';
import * as Graphdata from 'constants/Graphdata';
import { HOSTNAME } from 'constants/Jaws';

import * as Utils from 'utils/graphdata';
import doubleEncode from 'utils/doubleEncode';

function receiveSeries(componentId, bucketId, data) {
  return { type: types.GRAPHDATA_RECEIVE_SERIES, componentId, bucketId, data };
}

export function setup(componentId, itemSector) {
  return { type: types.GRAPHDATA_SETUP_COMPONENT, componentId, itemSector };
}

export function setItem(componentId, itemSector) {
  return dispatch => {
    dispatch({ type: types.GRAPHDATA_SET_ITEM, componentId, itemSector });
    dispatch(fetchData(componentId));
  };
}

function requestData(componentId) {
  return { type: types.GRAPHDATA_REQUEST_DATA, componentId };
}

export function setSelection(componentId, selection) {
  return dispatch => {
    dispatch({ type: types.GRAPHDATA_SET_SELECTION, componentId, selection });
    dispatch(fetchData(componentId));
  };
}

function addBucketWithSeries(componentId, bucketId, data) {
  return {
    type: types.GRAPHDATA_ADD_BUCKET_WITH_SERIES,
    componentId,
    bucketId,
    data,
  };
}

export function fetchData(componentId) {
  return (dispatch, getState) => {
    dispatch(requestData(componentId));
    const state = getState().graphdata.get(componentId);

    const itemSector = doubleEncode(state.get('itemSector'));
    const selection = state.get('selection');

    const url = Utils.buildURL({
      itemSector,
      space: Utils.getSpaceFromSelection(selection),
      series: Utils.getSeriesFromSelection(selection),
    });

    request
      .get(url)
      .query({
        period: Graphdata.PERIODS[selection],
        points: Graphdata.POINTS[selection],
      })
      .end((err, res) => {
        if (err) {
          throw new Error(err);
        }

        dispatch({ type: types.GRAPHDATA_CLEAR_BUCKETS, componentId });

        if (Utils.hasSeries(res.body)) {
          dispatch({
            type: types.GRAPHDATA_CREATE_BUCKET,
            componentId,
            bucketId: selection,
          });
          return dispatch(
            receiveSeries(componentId, selection, Utils.getSeries(res.body)),
          );
        }

        const buckets = Utils.getBuckets(res.body);
        const buffer = [];
        buckets.forEach(bucket => {
          dispatch({
            type: types.GRAPHDATA_CREATE_BUCKET,
            componentId,
            bucketId: bucket.get('stop'),
          });
          request
            .get(`${HOSTNAME}${bucket.get('link')}`)
            .end((bucketErr, bucketRes) => {
              if (bucketErr) {
                throw new Error(bucketErr);
              }

              bucket = bucket
                .set('series', Utils.getSeries(bucketRes.body))
                .set('isFetching', false);

              buffer.push(bucket);
              if (buffer.length >= 5) {
                buffer.forEach(item => {
                  dispatch(
                    addBucketWithSeries(componentId, item.get('stop'), item),
                  );
                });
              }
            });
        });
      });
  };
}
